export const VALIDATE_BULK_PHOTO_UPLOAD_END='validatebulkphotouploadend'
export const SHOW_BULK_UPLOAD='showBulkUpload'
export const CLOSE_BULK_UPLOAD='closeBulkUpload'
export const INIT_END='initBulkUploadEND'

